import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text } from '@ui-kitten/components';
import { StyleSheet, ScrollView } from 'react-native';
import { AvatarH } from './avatar.js';
import { Edit } from './edit-profile.js';
import { Action } from './action-list.js';
import { Settings } from './settings-list.js';
import { useIsFocused } from "@react-navigation/native";
import { StatusBar } from 'expo-status-bar';
import Constants from "expo-constants"

export const ProfileScreen = () => {
  const isVisible = useIsFocused();

  React.useEffect(()=>{
    console.log('test refreshing!');
  }, [isVisible])

  return (
      <Layout style={styles.container}>
        <Layout style={{backgroundColor:'#134A93'}}>
          <AvatarH />
        </Layout>
        <Divider />
        <Layout level='2' style={{flex:1}}>
          <ScrollView>
          <Text appearance='hint' category='c2' style={{marginHorizontal:20,marginTop:8}}>تنظیمات</Text>
          <Settings />
          <Text appearance='hint' category='c2' style={{marginHorizontal:20,marginTop:8}}>پشتیبانی</Text>
          <Action />
          <Text appearance='hint' category='c2' style={{marginHorizontal:20}}>ورژن {Constants.expoConfig.version}</Text>
          </ScrollView>
        </Layout>
        <StatusBar backgroundColor='#134A93' style="light" />
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
  },
});
